var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCl({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-cl",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M0 0h708.7v708.7H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "scale(.722)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M354.3 0H1063v354.3H354.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0039a6",
    d: "M0 0h354.3v354.3H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m232.3 265.3-55-41.1-54.5 41.5 20.3-67.5-54.5-41.7 67.4-.6 21-67.3 21.3 67.2h67.5L211.4 198l20.8 67.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    d: "M0 354.3h1063v354.4H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCl);
export default __webpack_public_path__ + "static/media/cl.819c84e5dfe6a6405c2040c5db06ea13.svg";
export { ForwardRef as ReactComponent };